module.exports = __webpack_public_path__ + "img/img_banner@2x (1).bb19821.png";